import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/6jSRxncYQsgYjPdJSouMGS/Mockup_1x1_-_OFN4_(Parkinson).webp';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-dark px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-64" data-mp="4m8ku8bjujit">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-brand-green/40" data-id="element-65" data-mp="129qv5nkuztox" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-66" data-mp="x9urxqjzk6af">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-[-10px] mt-[-45px] font-display text-lg font-bold tracking-[.18em] text-brand-light sm:text-2xl" data-id="element-67" data-mp="x8jmlmaw6qh7">
          🌿BIOMA LÍVIDO™
        </motion.p>
        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="mx-auto mt-5 max-w-5xl font-display text-[19px] font-bold text-white sm:text-5xl lg:text-6xl" data-id="element-68" data-mp="3d33d6tuq0lin">
          Volvé a acercarte a tu familiar con Párkinson después de una discusión en 14
          días, <span className="text-brand-light" data-id="element-69" data-mp="39authk0ozz0e">sin improvisar.</span>
        </motion.h1>
        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-70" data-mp="3e9625rf943h1">
          <img src={mockupUrl} alt="Mockup del Protocolo Reencuentro en Calma" width="1240" height="1240" loading="eager" fetchPriority="high" decoding="async" className="w-full drop-shadow-2xl" data-id="element-71" data-mp="358zp26ngt5ie" />
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.35
      }} className="mx-auto max-w-2xl" data-id="element-72" data-mp="2hkglg4fd1gwn">
          <p className="mb-[-8px] font-display text-base font-bold tracking-[.14em] text-brand-gold sm:text-xl" data-id="element-73" data-mp="s2tf1pz30hru">
            🏆 PROTOCOLO REENCUENTRO EN CALMA™
          </p>
          <p className="mt-3 text-sm leading-relaxed text-slate-200 sm:text-base" style={{
          marginBottom: '-10px'
        }} data-id="element-74" data-mp="ibp02q9eowx0">
            Sistema práctico de comunicación post-conflicto para ordenar lo ocurrido,
            retomar el diálogo y afrontar mejor el próximo acercamiento.
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-slate-300 sm:text-sm" style={{
          marginBottom: '-11px'
        }} data-id="element-75" data-mp="16346ov87u0e2">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-76" data-mp="x1wb4kx33dno">
              <FileTextIcon className="h-4 w-4 text-brand-light" aria-hidden="true" data-id="element-77" data-mp="3luiawvasv7nh" />
              100% PDF
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-78" data-mp="3htq03xma4up3">
              <ZapIcon className="h-4 w-4 text-brand-gold" aria-hidden="true" data-id="element-79" data-mp="21amwfav61umv" />
              Acceso en 5 min
            </span>
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.45
      }} className="mx-auto mt-7 max-w-lg" data-id="element-80" data-mp="268ofhvsldtyc">
          <ActionButton href="#pricing" showTrust data-id="element-81" data-mp="2g1wu3194vrnn">
            🧠 QUIERO MI PROTOCOLO AHORA
          </ActionButton>
        </motion.div>
      </div>
    </section>;
}